import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gap-20" }
const _hoisted_2 = { class: "radio-group primary small bold" }
const _hoisted_3 = { class: "radio-buttons" }
const _hoisted_4 = ["id", "value"]
const _hoisted_5 = ["for"]
const _hoisted_6 = { class: "d-flex gap-20 flex-column flex-md-row" }
const _hoisted_7 = { class: "d-flex align-items-end gap-20 w-100" }
const _hoisted_8 = { class: "custom-select links w-100" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "body-text" }, " Employer(s): ", -1)
const _hoisted_10 = { class: "d-flex gap-20 flex-md-row flex-column" }
const _hoisted_11 = { class: "custom-select links" }
const _hoisted_12 = { class: "body-text" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "custom-select links" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "body-text" }, "Payor(s): ", -1)
const _hoisted_16 = {
  key: 0,
  class: "d-flex gap-20 flex-md-row flex-column"
}
const _hoisted_17 = { class: "d-flex gap-20 flex-md-row flex-column" }
const _hoisted_18 = { class: "custom-select links" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "body-text" }, " Fund(s): ", -1)
const _hoisted_20 = {
  key: 1,
  class: "text-input"
}
const _hoisted_21 = { class: "d-flex gap-2 align-self-end justify-content-between w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "radio-button bordered-card bordered-card_secondary bg-light-green w-fit flex-column align-items-start"
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: `LocalType${index + 1}`,
              name: "LocalType",
              value: option.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.Local) = $event))
            }, null, 8, _hoisted_4), [
              [_vModelRadio, _ctx.filters.Local]
            ]),
            _createElementVNode("label", {
              class: "body-text",
              for: `LocalType${index + 1}`
            }, _toDisplayString(option.label), 9, _hoisted_5)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_DateInput, {
          label: "Work Period",
          modelValue: _ctx.filters.StartDate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.StartDate) = $event)),
          isRequired: true,
          error: _ctx.errors.StartDate
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_DateInput, {
          modelValue: _ctx.filters.EndDate,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.EndDate) = $event)),
          error: _ctx.errors.EndDate
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.filters.Employers,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.Employers) = $event)),
          options: _ctx.data.employers,
          placeholder: "Type to search",
          multiple: true,
          "hide-selected": true,
          searchable: true,
          "close-on-select": true,
          onSelect: _ctx.handleEmployerChange,
          label: "Name",
          "track-by": "ID",
          onSearchChange: _ctx.handleEmployersSearch,
          onRemove: _ctx.handleProductions,
          loading: _ctx.loading.employers
        }, null, 8, ["modelValue", "options", "onSelect", "onSearchChange", "onRemove", "loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("label", _hoisted_12, [
          _createTextVNode(" Production(s) "),
          (_ctx.hasEmployers)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, " for selected Employer(s)"))
            : _createCommentVNode("", true),
          _createTextVNode(": ")
        ]),
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.filters.Productions,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.Productions) = $event)),
          options: _ctx.data.productions,
          placeholder: "Type to search",
          multiple: true,
          "hide-selected": true,
          searchable: true,
          "close-on-select": true,
          onSelect: _ctx.handleProductionChange,
          label: "Name",
          "track-by": "ID",
          onOpen: _ctx.handleProductionsOpen,
          onSearchChange: _ctx.handleProductionsSearch,
          loading: _ctx.loading.productions
        }, null, 8, ["modelValue", "options", "onSelect", "onOpen", "onSearchChange", "loading"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.filters.Payors,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.Payors) = $event)),
          options: _ctx.data.payors,
          placeholder: "Type to search",
          multiple: true,
          searchable: true,
          "close-on-select": true,
          label: "Name",
          "track-by": "ID",
          onSelect: _ctx.handlePayorChange,
          onSearchChange: _ctx.handlePayorsSearch,
          loading: _ctx.loading.payors
        }, null, 8, ["modelValue", "options", "onSelect", "onSearchChange", "loading"])
      ])
    ]),
    (_ctx.filters.Local === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_TextInput, {
            type: "text",
            label: "First Name",
            placeholder: "Enter First Name",
            max: 12,
            modelValue: _ctx.filters.FirstName,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.FirstName) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_TextInput, {
            type: "text",
            label: "Last Name",
            placeholder: "Enter Last Name",
            max: 12,
            modelValue: _ctx.filters.LastName,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.LastName) = $event))
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      (_ctx.filters.Local === 0)
        ? (_openBlock(), _createBlock(_component_TextInput, {
            key: 0,
            type: "text",
            name: "number",
            label: "NBF Participant ID or SSN",
            placeholder: "Enter NBF Participant ID or SSN",
            max: 25,
            modelValue: _ctx.filters.ParticipantID,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.ParticipantID) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.filters.Funds,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.Funds) = $event)),
          options: _ctx.data.funds,
          placeholder: "Type to search",
          multiple: true,
          label: "Name",
          "track-by": "ID",
          searchable: true,
          "close-on-select": true,
          onSelect: _ctx.handleFundChange
        }, null, 8, ["modelValue", "options", "onSelect"])
      ]),
      (_ctx.filters.Local !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary h-1",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
      }, "Clear Filters"),
      _createElementVNode("button", {
        class: "btn btn-primary h-1",
        onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchData && _ctx.searchData(...args)), ["prevent"])),
        onKeypress: _cache[12] || (_cache[12] = _withKeys(
//@ts-ignore
(...args) => (_ctx.searchData && _ctx.searchData(...args)), ["enter"]))
      }, _toDisplayString(_ctx.loadingSearch ? 'Searching...' : 'Apply Filters'), 33)
    ])
  ]))
}